import Vue from 'vue'
import Router from 'vue-router'

import login from '@/components/login/login'
import index from '@/components/index/indexApp'
import indexEmpty from '@/components/index/indexEmpty'
import oauthCallback from '@/components/login/oauth-callback'

Vue.use(Router)

const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        name: 'index2',
        component: index
    },
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/index',
        name: 'index',
        component: index
    },
    {
        path: '/oauth/callback',
        name: 'oauth-callback',
        component: oauthCallback
    },
    {
        path: '*',
        name: 'empty',
        component: indexEmpty
    },
    {
        path: '/qms/notification/document/detail',
        name: 'qms-notification-document-detail',
        component: () => import('@/components/content/qms/notification/qms-notification-document-preview.vue')
    }
]

const router = new Router({
    mode: 'history',
    routes: [
        ...routes
    ]
})

// 前置路由守卫
router.beforeEach((to, from, next) => {
    // store.dispatch('i18nProp/getI18nProp')
    if (from.path !== to.path && !routeExists(to.path)) {
        // router.addRoute({
        //     path: to.path,
        //     name: to.path.slice(1),
        //     component: import(`@/components/content${to.path}.vue`)
        // })
    }
    next()
})

function routeExists (path) {
    return router.options.routes.some(route => route.path === path)
}

export function addRoutes (compsIndexes) {
    for (const item of compsIndexes) {
        router.addRoute(item)
    }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js